<script>
import { Bar } from 'vue-chartjs'

// const { reactiveProp } = mixins

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    let options = {
      responsive: true,
      maintainAspectRatio: false,
      height: 300,
      legend: { position: 'bottom' },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false
          }
        }],
         yAxes: [{
             ticks: {
                 beginAtZero: true,
                 userCallback: function(label) {
                     // when the floored value is the same as the value we have a whole number
                     if (Math.floor(label) === label) {
                         return label;
                     }

                 },
             }
         }],
     }
    }
    this.renderChart(this.chartData, options)
  }
}
</script>
